import React, { Component } from "react";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { AvForm, AvField } from "availity-reactstrap-validation";
import firebase from "../../config/firebase";
import { CKEditor } from "@ckeditor/ckeditor5-react";
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
import renderHTML from "react-render-html";
import {
  FormGroup,
  Row,
  Col,
  CustomInput,
  Label,
  FormText,
  Alert,
  Input,
  ModalFooter,
  ModalBody,
  Modal,
  ModalHeader,
  Button,
} from "reactstrap";
import { Pagination, PaginationItem, PaginationLink } from "reactstrap";
import Navigations from "../../config/navbarAdmin";
import Sidebar from "../../config/Sidebar";
import "../../Sidebar.css";
import './Projectstyle.css'
// import "../../screens/Admin/styles.css";
var db = firebase.database();
class AddProjects extends Component {
  constructor(props) {
    super(props);

    this.state = {
      headingName: "",
      category: "web-apps",
      status: false,
      body: "",
      githubLink: "",
      buttonLink: "",
      arr: [],
      image: null,
      url: "",
      progress: 0,
      currentPage: 0,
      pageSize: 5,
    };

    this.onHandleChange = this.onHandleChange.bind(this);
    this.onDismiss = this.onDismiss.bind(this);
    this.changeHandler = this.changeHandler.bind(this);
    // this.customInputSwitched =this.customInputSwitched.bind(this);
  }

  customInputSwitched(buttonName, e) {
    this.setState({ status: e.target.checked });
  }
  changeHandler(e) {
    console.log(e.target.value);
    e.preventDefault();
    this.setState({ [e.target.name]: e.target.value });
  }

  handleClick(e, index) {
    e.preventDefault();
    this.setState({
      currentPage: index,
    });
  }

  onDismiss() {
    this.setState({ visiableError: false });
  }

  onHandleChange(e) {
    this.setState({ body: e });
  }

  handleChange = (e) => {
    if (e.target.files[0]) {
      const image = e.target.files[0];
      this.setState(() => ({ image }));
    }
  };
  componentDidUpdate(prevProps, prevState) {
    if (this.state.visible) {
      // when the state is updated (turned red),
      // a timeout is triggered to switch it back off
      this.turnOffRedTimeout = setTimeout(() => {
        this.setState(() => ({ visible: false }));
      }, 1000);
    }
  }

  search = (e) => {
    const { arr } = this.state;
    const textSearch = e.target.value;
    // console.log(textSearch)
    const searchData = arr.filter((elem) => {
      return (
        elem.headingName.substring(0, textSearch.length).toUpperCase() ===
        textSearch.toUpperCase()
      );
    });
    // console.log(searchData)
    this.setState({
      searchData,
      textSearch,
    });
    // console.log(result)
  };

  filterData = (e) => {
    this.setState({
      pageSize: e,
    });
  };

  componentDidMount() {
    db.ref("Projects").on("value", (snapshot) => {
      var newArr = [];
      snapshot.forEach((data) => {
        var childData = data.val();
        console.log(childData);
        newArr.push(childData);
      });
      this.setState({ arr: newArr.reverse() });
    });
  }

  componentWillUnmount() {
    // we set the timeout to this.turnOffRedTimeout so that we can
    // clean it up when the component is unmounted.
    // otherwise you could get your app trying to modify the state on an
    // unmounted component, which will throw an error
    clearTimeout(this.turnOffRedTimeout);
  }

  submit = () => {
    const {
      status,
      headingName,
      body,
      githubLink,
      buttonLink,
      image,
      category,
      url,
    } = this.state;

    var currentUser = firebase.auth().currentUser.uid;

    if (image == null || image.name === undefined) {
      // alert('please add image')
      this.setState({
        errorImage: true,
      });
    } else {
      var newPostKey = db.ref().child("Projects").push().key;
      const uploadTask = firebase
        .storage()
        .ref(`Projects/${image.name}`)
        .put(image)
        .then((snapshot) => {
          return snapshot.ref.getDownloadURL(); // Will return a promise with the download link
        })

        .then((downloadURL) => {
          console.log(
            `Successfully uploaded file and got download link - ${downloadURL}`
          );
          // return downloadURL;
          this.setState({ url: downloadURL });
          var onj = {
            headingName,
            body,
            githubLink,
            buttonLink,
            image,
            category,
            status,
            currentUser,
            createAt: new Date().toLocaleString(),
            downloadURL,
            newPostKey,
          };
          if (headingName === "" && body === "" && uploadTask === "") {
            alert("Please Fill All field");
          } else {
            db.ref("Projects/" + newPostKey)
              .set(onj)
              .then((e) => {
                this.setState({
                  success: "Successfully",
                  visible: true,
                  modal: false,
                });
              })
              .catch((error) => {
                console.log("Error: ", error);
                this.setState({
                  errorMessage: error.message,
                  visiableError: true,
                });
              });
            this.setState({
              headingName: "",
              body: "",
              githubLink: "",
              buttonLink: "",
            });
          }
        })
        .catch((error) => {
          // Use to signal error if something goes wrong.
          console.log(`Failed to upload file and get link - ${error}`);
          this.setState({
            errorMessage: error.message,
            visiableError: true,
          });
        });
    }
  };

  delete = (id, image) => {
    db.ref("Projects/" + id)
      .remove()
      .then((e) => {
        console.log("success", e);
        alert("Deleted Successfully");
        toast.success("Deleted Successfully !", {
          position: toast.POSITION.TOP_RIGHT,
        });
        let name = image.substr(
          image.indexOf("%2F") + 3,
          image.indexOf("?") - (image.indexOf("%2F") + 3)
        );
        name = name.replace("%20", " ");
        console.log(name);
        let storagePath = firebase.storage().ref();
        storagePath
          .child(`Projects/${name}`)
          .delete()
          .then(() => {
            // File deleted successfully
            console.log("deleted");
          })
          .catch((error) => {
            // Uh-oh, an error occurred!
          });
      })
      .catch((error) => {
        console.log("error", error);
        alert("Error: ", error);
        this.setState({
          errorMessage: error.message,
          visiableError: true,
        });
      });
  };

  handleUpdateImage = (e) => {
    if (e.target.files[0]) {
      const imageUpdate = e.target.files[0];

      this.setState(() => ({ imageUpdate }));
    }
  };
  userImageUpdat = () => {
    const { localImage, image, userDataKey, imageUpdate, localImageKey } =
      this.state;
    console.log({ localImage, image, userDataKey, imageUpdate, localImageKey });
    this.setState({
      loaderToggle: true,
    });
    const path = "Avatar_" + localImageKey + ".jpg";
    const uploadTask = firebase
      .storage()
      // .ref(`User_Data/${image.name}`)
      .ref(`Projects/${path}`)
      .put(imageUpdate)
      .then((snapshot) => {
        return snapshot.ref.getDownloadURL(); // Will return a promise with the download link
      })
      .then((downloadURL) => {
        console.log(
          `Successfully uploaded file and got download link - ${downloadURL}`
        );
        // return downloadURL
        this.setState({ url: downloadURL });
        var obj = {
          downloadURL,
        };

        firebase
          .database()
          .ref("Projects/" + localImageKey)
          .update(obj)
          .then((e) => {
            this.setState({
              toggleEditImage: !this.state.toggleEditImage,
              loaderToggle: false,
            });
            // window.location.reload();
          })
          .catch((error) => {
            console.log("Error: ", error.message);
          });
      })
      .catch((error) => {
        console.log(`Failed to upload file and get link - ${error}`);
      });
  };

  submitEdit = () => {
    const {
      status,
      headingName,
      category,
      body,
      githubLink,
      buttonLink,
      newPostKey,
    } = this.state;
    var oin = {
      headingName,
      category,
      body,
      githubLink,
      buttonLink,
      newPostKey,
      status,
      updateAt: new Date().toLocaleString(),
    };

    firebase
      .database()
      .ref("Projects/" + newPostKey)
      .update(oin)
      .then((e) => {
        // this.props.history.push("/AddProjects");
        console.log("success", e);
        alert("success");
        this.setState({
          success: "Successfully",
          visible: true,
          modal: false,
        });
      })
      .catch((error) => {
        console.log("Error: ", error);
        alert("Error");
      });
  };
  render() {
    const {
      arr,
      category,
      image,
      errorMessage,
      errorImage,
      success,
      textSearch,
      searchData,
      currentPage,
      pageSize,
    } = this.state;
    var errmsg = errorMessage || errorImage;
    var imgCheck = image && image.name;
    const string = Math.ceil(arr.length / pageSize);
    var res = [...Array(string)];
    const sear = textSearch ? searchData : arr;
    return (
      <div class="sb-nav-fixed " id="zoomed">
        <Navigations />
        <div id="layoutSidenav">
          <Sidebar />
          <div id="layoutSidenav_content">
            <main>
              <div class="container-fluid">
                <Modal
                  isOpen={this.state.modal}
                  backdrop="static"
                  size="xl"
                  scrollable={true}
                >
                  <ModalHeader
                    close={
                      <button
                        className="close"
                        onClick={() =>
                          this.setState({
                            modal: !this.state.modal,
                          })
                        }
                      >
                        &times;
                      </button>
                    }
                  >
                    {this.state.edit === true ? "Edit" : "Add"} Projects
                  </ModalHeader>

                  <ModalBody>
                    {errmsg && (
                      <Alert
                        style={{
                          paddingTop: "11px",
                          marginTop: "-17px",
                        }}
                        color="danger"
                        isOpen={this.state.visiableError}
                        toggle={this.onDismiss}
                      >
                        <span>Please Fill All Field</span>
                      </Alert>
                    )}
                    {success && (
                      <Alert
                        style={{
                          paddingTop: "11px",
                          marginTop: "-17px",
                        }}
                        color="success"
                        isOpen={this.state.visible}
                        toggle={this.onDismiss}
                      >
                        <span>Submit Successfully</span>
                      </Alert>
                    )}
                    <AvForm>
                      <Row>
                        <Col md="4">
                          <FormGroup>
                            {/* <Label for="exampleEmail">Heading</Label> */}
                            <AvField
                              type="text"
                              label="Heading Name"
                              value={this.state.headingName}
                              name="headingName"
                              id="exampleEmail"
                              placeholder="Heading Name"
                              onChange={this.changeHandler}
                              required
                            />
                          </FormGroup>
                        </Col>
                        <Col md="4">
                          <FormGroup>
                            <Label for="exampleSelect">Category</Label>
                            <Input
                              type="select"
                              name="category"
                              id="exampleSelect"
                              value={category}
                              onChange={this.changeHandler}
                            >
                              <option value="web-apps">WEB APPS</option>
                              <option value="mobile-app">MOBILE APPS</option>
                              {/* <option value="react">React</option>
                                  <option value="react native">
                                    React Native
                                  </option> */}
                            </Input>
                          </FormGroup>
                        </Col>
                        <Col md="4">
                          <FormGroup>
                            {/* <Label for="exampleText">body</Label> */}
                            <AvField
                              type="text"
                              label="Button Link"
                              value={this.state.buttonLink}
                              placeholder="Button Link"
                              id="exampleText"
                              name="buttonLink"
                              onChange={this.changeHandler}
                              required
                            />
                          </FormGroup>
                        </Col>
                      </Row>
                      {/* <ReactQuill
                    value={this.state.body}
                    modules={EditProjects.modules}
                    formats={EditProjects.formats}
                    placeholder="Write Something Creative"
                    onChange={this.onHandleChange}
                  /> */}
                      <div class="">
                        <CKEditor
                           editor={ClassicEditor}
                           config={{
                             heading: {
                               options: [
                                 {
                                   model: "paragraph",
                                   title: "Paragraph",
                                   class: "ck-heading_paragraph",
                                 },
                                 // {
                                 //   model: "heading1",
                                 //   view: "h1",
                                 //   title: "Heading 1",
                                 //   class: "ck-heading_heading1",
                                 // },
                                 // {
                                 //   model: "heading2",
                                 //   view: "h2",
                                 //   title: "Heading 2",
                                 //   class: "ck-heading_heading2",
                                 // },
                                 // {
                                 //   model: "heading3",
                                 //   view: "h3",
                                 //   title: "Heading 3",
                                 //   class: "ck-heading_heading3",
                                 // },
                                 {
                                   model: "heading4",
                                   view: "h4",
                                   title: "Heading 4",
                                   class: "ck-heading_heading4",
                                 },
                                 {
                                   model: "heading5",
                                   view: "h5",
                                   title: "Heading 5",
                                   class: "ck-heading_heading5",
                                 },
                                 {
                                   model: "heading6",
                                   view: "h6",
                                   title: "Heading 6",
                                   class: "ck-heading_heading6",
                                 },
                               ],
                             },
                             // plugins: [Paragraph, Bold, Italic, Essentials],
                             alignment: {
                               options: [
                                 { name: "left", className: "my-align-left" },
                                 { name: "right", className: "my-align-right" },
                               ],
                             },
                             toolbar: [
                               "heading",
                               "|",
                               "bold",
                               "italic",
                               "link",
                               "bulletedList",
                               "numberedList",
                               "blockQuote",
                               // "bulletedList",
                               // "numberedList",
                               "alignment",
                               "undo",
                               "redo",
                               // "bold",
                               // "italic",
                             ],
                           }}
                          data={this.state.body}
                          onReady={(editor) => {
                            console.log("Editor is ready to use!", editor);
                          }}
                          onChange={(event, editor) => {
                            const data = editor.getData();
                            console.log({ event, editor, data });
                            this.setState({ body: data });
                          }}
                          onBlur={(event, editor) => {
                            console.log("Blur.", editor);
                          }}
                          onFocus={(event, editor) => {
                            console.log("Focus.", editor);
                          }}
                        />
                      </div>

                      <div class="row mt-3">
                        <Col md={this.state.edit === true ? "8" : "4"}>
                          <FormGroup>
                            {/* <Label for="exampleEmail">Heading</Label> */}
                            <AvField
                              type="text"
                              label="Github Link"
                              value={this.state.githubLink}
                              id="exampleEmail"
                              placeholder="Github Link"
                              name="githubLink"
                              onChange={this.changeHandler}
                              required
                            />
                          </FormGroup>
                        </Col>
                        {this.state.edit === true ? (
                          ""
                        ) : (
                          <Col md="4">
                            <FormGroup>
                              <Label for="exampleCustomFileBrowser">
                                Choose File
                              </Label>
                              <CustomInput
                                type="file"
                                id="exampleCustomFileBrowser"
                                name="customFile"
                                label={image && image.name}
                                onChange={this.handleChange}
                              />
                              {imgCheck || this.state.errorImage ? (
                                <FormText color="danger">
                                  {image && image.name
                                    ? " "
                                    : "Please Add Image"}
                                </FormText>
                              ) : (
                                <FormText color="danger"></FormText>
                              )}
                            </FormGroup>
                          </Col>
                        )}
                        <Col md="4">
                          <Label for="exampleCheckbox">Status</Label>
                          <div>
                            <CustomInput
                              checked={
                                this.state.status === false ? false : true
                              }
                              type="switch"
                              id="exampleCustomSwitch"
                              name="status"
                              label={
                                this.state.status === false
                                  ? "Not Active"
                                  : "Active"
                              }
                              value={this.state.status}
                              onChange={this.customInputSwitched.bind(
                                this,
                                true
                              )}
                            />
                          </div>
                        </Col>
                      </div>
                    </AvForm>
                  </ModalBody>
                  <ModalFooter>
                    {this.state.edit === true ? (
                      <button
                        type="button"
                        class="btn btn-outline-success"
                        onClick={() => this.submitEdit()}
                      >
                        Edit Project
                      </button>
                    ) : (
                      <button
                        type="button"
                        class="btn btn-outline-success"
                        onClick={() => this.submit()}
                      >
                        Add Project
                      </button>
                    )}
                    <button
                      type="button"
                      class="btn btn-outline-secondary"
                      onClick={() =>
                        this.setState({
                          modal: !this.state.modal,
                        })
                      }
                    >
                      Cancel
                    </button>
                  </ModalFooter>
                </Modal>
                <Modal
                  isOpen={this.state.modalDetail}
                  backdrop="static"
                  size="xl"
                  scrollable={true}
                >
                  <ModalHeader
                    close={
                      <button
                        className="close"
                        onClick={() =>
                          this.setState({
                            modalDetail: !this.state.modalDetail,
                          })
                        }
                      >
                        &times;
                      </button>
                    }
                  >
                    {" "}
                    Projects Detail
                  </ModalHeader>

                  <ModalBody>
                    <div class="">
                      <div class="">
                        <h5 class="alert alert-primary" role="alert">
                          {this.state.headingName}
                        </h5>
                        <p class="alert alert-secondary" role="alert">
                          {renderHTML(this.state.body)}
                        </p>
                        <p class="alert alert-success" role="alert">
                          Button Link: {this.state.buttonLink} <br />
                          Github Link: {this.state.githubLink} <br />
                          Create At: {this.state.createAt} <br />
                          Update At: {this.state.updateAt}
                        </p>
                      </div>
                      <img
                        src={this.state.downloadURL}
                        class="card-img-bottom"
                        alt="..."
                        style={{ width: "100%", height: "100%" }}
                      />
                    </div>
                  </ModalBody>
                  <ModalFooter>
                    <button
                      type="button"
                      class="btn btn-outline-secondary"
                      onClick={() =>
                        this.setState({
                          modalDetail: !this.state.modalDetail,
                        })
                      }
                    >
                      Close
                    </button>
                  </ModalFooter>
                </Modal>
                <Modal
                  size="lg"
                  isOpen={this.state.toggleEditImage}
                  toggle={this.state.toggle}
                  //   className={className}
                  //   backdrop={backdrop}
                  backdrop="static"
                  //   keyboard={keyboard}
                >
                  <div
                    class="mt-4 mr-4 ml-4"
                    style={{
                      display: "flex",
                      flexDirection: "row",
                      justifyContent: "space-between",
                    }}
                  >
                    <h5 toggle={this.state.toggle}>Edit User Image</h5>
                  </div>
                  <hr />
                  <ModalBody>
                    <div
                      class="pic"
                      style={{ justifyContent: "center", display: "flex" }}
                    >
                      <img
                        onClick={() =>
                          this.setState({
                            toggleEditImage: !this.state.toggleEditImage,
                          })
                        }
                        src={this.state.localImage}
                        class="img-fluid"
                        alt=""
                        style={{ height: "400px", width: "550px" }}
                      />
                    </div>
                    <div
                      class="custom-file  mt-4"
                      style={{ justifyContent: "center", display: "flex" }}
                    >
                      <CustomInput
                        type="file"
                        id="exampleCustomFileBrowser"
                        name="customFile"
                        label={image && image.name}
                        onChange={this.handleUpdateImage}
                      />
                      {imgCheck || this.state.errorImage ? (
                        <FormText color="danger">
                          {image && image.name ? " " : "Please Add Image"}
                        </FormText>
                      ) : (
                        <FormText color="danger"></FormText>
                      )}
                    </div>
                  </ModalBody>
                  <ModalFooter
                    style={{ display: "flex", justifyContent: "space-between" }}
                  >
                    <div>
                      <Button
                        className="mr-2"
                        color="primary"
                        onClick={
                          () => this.userImageUpdat()
                          // this.setState({
                          //   modal: !this.state.modal,
                          // })
                        }
                      >
                        Edit
                      </Button>

                      <Button
                        color="secondary"
                        onClick={() =>
                          this.setState({
                            toggleEditImage: !this.state.toggleEditImage,
                          })
                        }
                      >
                        Cancel
                      </Button>
                    </div>
                  </ModalFooter>
                </Modal>

                <div class="d-flex align-items-center">
                  <h1
                    style={{ color: "rgb(118, 102, 223)", fontSize: 50 }}
                    class="mt-3"
                  >
                    <i class="fas fa-tasks"></i> Projects
                  </h1>
                  <button
                    type="button"
                    class="btn btn-outline-primary ml-auto"
                    // data-toggle="modal"
                    // data-target="#staticBackdrop "
                    onClick={() =>
                      this.setState({
                        modal: !this.state.modal,
                        headingName: "",
                        category: "web-apps",
                        body: "",
                        githubLink: "",
                        buttonLink: "",
                        newPostKey: "",
                        downloadURL: "",
                        status: false,
                        edit: false,
                      })
                    }
                  >
                    Add Project
                  </button>
                </div>

                {/* <div className="view-content">{this.renderPosts()}</div> */}
                <div>
                  <div class="tile">
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                      }}
                    >
                      <div style={{ marginBottom: 10 }}>
                        <ul class=" nav nav-pills">
                          <li class="nav-item dropdown">
                            <a
                              class="nav-link dropdown-toggle active"
                              data-toggle="dropdown"
                              href="#/"
                              role="button"
                              aria-haspopup="true"
                              aria-expanded="false"
                            >
                              Show Enteries: {pageSize}
                            </a>
                            <div class="dropdown-menu">
                              <a
                                style={{ cursor: "pointer" }}
                                class="dropdown-item"
                                onClick={() => this.filterData(5)}
                              >
                                5
                              </a>
                              <a
                                style={{ cursor: "pointer" }}
                                class="dropdown-item"
                                onClick={() => this.filterData(10)}
                              >
                                10
                              </a>
                              <a
                                style={{ cursor: "pointer" }}
                                class="dropdown-item"
                                onClick={() => this.filterData(25)}
                              >
                                25
                              </a>
                              <a
                                style={{ cursor: "pointer" }}
                                class="dropdown-item"
                                onClick={() => this.filterData(100)}
                              >
                                100
                              </a>
                            </div>
                          </li>
                        </ul>
                      </div>

                      <div style={{ marginBottom: 10 }}>
                        <input
                          class="form-control"
                          placeholder="Search by File Name"
                          onChange={this.search.bind(this)}
                        />
                      </div>
                    </div>

                    <div class="table-responsive">
                      <table
                        class="table table-bordered table-hover table-striped"
                        // id="dataTable"
                        width="100%"
                        cellspacing="0"
                      >
                        <thead>
                          <tr>
                            <th style={{ fontWeight: 100 }}>Image</th>
                            <th style={{ fontWeight: 100 }}>File Name</th>
                            <th style={{ fontWeight: 100 }}>Category</th>
                            <th style={{ fontWeight: 100 }}>Create At</th>
                            {/* <th style={{ fontWeight: 100 }}>Update At</th> */}
                            <th style={{ fontWeight: 100 }}>Is Active</th>

                            <th style={{ fontWeight: 100 }}>Actions</th>
                          </tr>
                        </thead>
                        <tbody>
                          {sear
                            .slice(
                              currentPage * pageSize,
                              (currentPage + 1) * pageSize
                            )
                            .map((en, index) => {
                              return (
                                <tr key={index}>
                                  <td align="">
                                    <img
                                      onClick={() =>
                                        this.setState({
                                          toggleEditImage:
                                            !this.state.toggleEditImage,
                                          localImage: en.downloadURL,
                                          localImageKey: en.newPostKey,
                                        })
                                      }
                                      src={en.downloadURL}
                                      class="img-fluid"
                                      alt=""
                                      style={{
                                        height: "33px",
                                        width: "50px",
                                      }}
                                    />
                                  </td>
                                  <td align="">{en.headingName}</td>
                                  <td align="">{en.category}</td>
                                  <td align="">{en.createAt}</td>
                                  {/* <td align="">{en.updateAt}</td> */}
                                  <td align="">
                                    {en.status === true ? (
                                      <span style={{ color: "green" }}>
                                        True
                                      </span>
                                    ) : (
                                      <span style={{ color: "red" }}>
                                        False
                                      </span>
                                    )}
                                  </td>

                                  <td style={{}} align="">
                                    <button
                                      style={{ marginRight: 5 }}
                                      class="btn btn-primary btn-sm"
                                      onClick={() => {
                                        this.setState({
                                          headingName: en.headingName,
                                          category: en.category,
                                          body: en.body,
                                          githubLink: en.githubLink,
                                          buttonLink: en.buttonLink,
                                          newPostKey: en.newPostKey,
                                          downloadURL: en.downloadURL,
                                          createAt: en.createAt,
                                          updateAt: en.updateAt,
                                          modalDetail: !this.state.modalDetail,
                                        });
                                      }}
                                    >
                                      {/* <i class="fa  fa-trash fa-2x"></i>{" "} */}
                                      VIEW
                                    </button>
                                    <button
                                      style={{ marginRight: 5 }}
                                      class="btn btn-success btn-sm"
                                      onClick={() => {
                                        this.setState({
                                          headingName: en.headingName,
                                          category: en.category,
                                          body: en.body,
                                          githubLink: en.githubLink,
                                          buttonLink: en.buttonLink,
                                          newPostKey: en.newPostKey,
                                          downloadURL: en.downloadURL,
                                          status: en.status,
                                          modal: !this.state.modal,
                                          edit: true,
                                        });
                                      }}
                                    >
                                      {/* <i class="fa  fa-trash fa-2x"></i>{" "} */}
                                      EDIT
                                    </button>
                                    <button
                                      // style={{ color: "red" }}
                                      class="btn btn-danger btn-sm"
                                      onClick={() => {
                                        if (
                                          window.confirm(
                                            "Are you sure to delete this?"
                                          )
                                        ) {
                                          this.delete(
                                            en.newPostKey,
                                            en.downloadURL
                                          );
                                        }
                                      }}
                                    >
                                      {/* <i class="fa  fa-trash fa-2x"></i>{" "} */}
                                      DELETE{" "}
                                    </button>
                                  </td>
                                </tr>
                              );
                            })}
                        </tbody>
                      </table>

                      <div
                        style={{
                          display: "flex",
                          // justifyContent: "space-between",
                          justifyContent: "center",
                        }}
                      >
                        <div style={{ justifyContent: "flex-start" }}>
                          {/* <p>
                            Showing 1 to {sear.length} of {sear.length} entries
                          </p> */}
                        </div>
                        <div style={{ justifyContent: "flex-end" }}>
                          <Pagination aria-label="Page navigation example">
                            <PaginationItem disabled={currentPage <= 0}>
                              <PaginationLink
                                onClick={(e) =>
                                  this.handleClick(e, currentPage - 1)
                                }
                                previous
                                href="javascript:void(0)"
                              />
                            </PaginationItem>
                            {res.map((page, i) => (
                              <PaginationItem
                                active={i === currentPage}
                                key={i}
                              >
                                <PaginationLink
                                  onClick={(e) => this.handleClick(e, i)}
                                  href="javascript:void(0)"
                                >
                                  {i + 1}
                                </PaginationLink>
                              </PaginationItem>
                            ))}
                            <PaginationItem
                              disabled={currentPage >= res.length - 1}
                            >
                              <PaginationLink
                                onClick={(e) =>
                                  this.handleClick(e, currentPage + 1)
                                }
                                next
                                href="javascript:void(0)"
                              />
                            </PaginationItem>
                          </Pagination>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </main>
          </div>
        </div>
      </div>
    );
  }
}
AddProjects.modules = {
  toolbar: [
    [{ header: "1" }, { header: "2" }, { font: [] }],
    [{ size: [] }],
    ["bold", "italic", "underline", "strike", "blockquote"],
    [
      { list: "ordered" },
      { list: "bullet" },
      { indent: "-1" },
      { indent: "+1" },
    ],
    ["link", "image", "video"],
    ["clean"],
  ],
  clipboard: {
    // toggle to add extra line breaks when pasting HTML:
    matchVisual: false,
  },
  // theme: 'snow',
};
/*
 * Quill editor formats
 * See https://quilljs.com/docs/formats/
 */
AddProjects.formats = [
  "header",
  "font",
  "size",
  "bold",
  "italic",
  "underline",
  "strike",
  "blockquote",
  "list",
  "bullet",
  "indent",
  "link",
  "image",
  "video",
];

/*
 * PropType validation
 */
//   Editor.propTypes = {
//     placeholder: PropTypes.string,
//   }
const mapStateToProps = (state) => {
  return {
    user: state.user,
    dwOpen: state.dw,
  };
};

export default withRouter(connect(mapStateToProps, null)(AddProjects));
